// src/pages/SubscriptionCancelledPage.tsx
// Public cancellation page shown when user cancels Stripe checkout

import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

export default function SubscriptionCancelledPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FAFAFA] via-white to-[#18365E]/5 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* DVA Logo */}
        <div className="text-center mb-8">
          <span className="text-3xl font-bold text-[#18365E] tracking-tight">DVA</span>
        </div>

        {/* Cancel Card */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
          <AlertCircle className="w-16 h-16 text-amber-500 mx-auto mb-4" />

          <h1 className="text-2xl font-bold text-[#18365E] text-center mb-3">
            Subscription Cancelled
          </h1>

          <p className="text-center text-[#717182] mb-2">
            You cancelled the upgrade process. No charges were made to your account.
          </p>

          <p className="text-center text-sm text-[#717182] mb-6">
            You can upgrade to DVA Pro anytime from your account settings.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/freemium/upgrade')}
              className="w-full py-3 bg-[#FF6E4C] text-white rounded-xl font-semibold hover:bg-[#ff5a3a] transition-all"
            >
              Try Again
            </button>
            <button
              onClick={() => navigate('/home')}
              className="w-full py-3 bg-white text-[#18365E] rounded-xl font-semibold ring-1 ring-[#e5e7eb] hover:ring-[#18365E] transition-all"
            >
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
